import api from "./axios";

/**
 * Backend contract (admin):
 * GET  /health/carousel
 *      → { response: { carousel: [{
 *            imageUrl, title?, description?, linkUrl?, useStoryImage?, storyImageUrl?, sortOrder?
 *          }, ...] } }
 *
 * PUT  /health/carousel  (multipart/form-data)
 *      - carousel: JSON string — array aligned with slides (top to bottom). Each item:
 *          { title?, description?, linkUrl?, useStoryImage?, storyImageUrl?: string | null, imageUrl: string | null }
 *        - imageUrl: existing CDN URL to keep, or null → next file in `images` (same order as nulls).
 *      - images: repeated field `images` — new/changed files only, same order as null imageUrl slots.
 */

function unwrap(res) {
  return res?.response ?? res;
}

export async function getHealthScreenConfig() {
  const res = await api.get("/health/carousel");
  const payload = unwrap(res);
  const carousel =
    payload?.carousel ??
    payload?.data?.carousel ??
    (Array.isArray(payload) ? payload : []);
  return {
    carousel: Array.isArray(carousel) ? carousel : [],
  };
}

/**
 * @param {{ carousel: Array<{ title?: string, description?: string, linkUrl?: string, imageUrl: string | null }>, files: File[] }} payload
 */
export async function updateHealthScreenConfigMultipart({ carousel, files }) {
  const fd = new FormData();
  fd.append("carousel", JSON.stringify(carousel));
  (files || []).forEach((file) => {
    fd.append("images", file);
  });
  const res = await api.put("/health/carousel", fd);
  return unwrap(res);
}
